module.exports = __webpack_public_path__ + "img/doclnia.5d67a3bd.png";